function toggleAdvancedBlock(show) {
  const toggleButton    = $('*[data-target="settings-advanced-toggle"]');
  const collapseSection = $('#collapse-advanced-section');

  if (show) {
    toggleButton.html("Advanced &blacktriangledown;");
    toggleButton.removeClass('btn-outline-primary').addClass('btn-primary');
    collapseSection.addClass('show');
  } else {
    toggleButton.html("Advanced &blacktriangleright;");
    toggleButton.addClass('btn-outline-primary').removeClass('btn-primary');
    collapseSection.removeClass('show');
  }
}

$(function() {
  toggleAdvancedBlock(
    $('[name="team[advanced-instagram-handles][]"] option:selected').length ||
    $('[name="team[advanced-terms]"]').val() ||
    $('[name="brand_info[advanced-instagram-handles][]"] option:selected').length ||
    $('[name="brand_info[advanced-terms]"]').val()
  );

  const toggleButton = $('*[data-target="settings-advanced-toggle"]');

  toggleButton.on('click', (e) => {
    e.preventDefault();
    toggleAdvancedBlock(!toggleButton.hasClass('collapsed'));
  });
});
